import { useDailyStatus } from '../dailyStatusStore';
import { useT } from '../i18n';

export function StreakRing() {
  const status = useDailyStatus();
  const { t } = useT();
  const current = status?.streak.currentStreak ?? 0;
  const longest = status?.streak.longestStreak ?? 0;

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: 12,
        padding: '10px 14px',
        background: 'rgba(0, 212, 255, 0.08)',
        border: '1px solid rgba(0, 212, 255, 0.4)',
        borderRadius: 8,
      }}
    >
      <div
        style={{
          width: 48,
          height: 48,
          borderRadius: '50%',
          background: 'radial-gradient(circle at 30% 30%, #00d4ff, #0099cc)',
          color: '#001020',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontWeight: 800,
          fontSize: 22,
          boxShadow: '0 0 12px rgba(0,212,255,0.6)',
        }}
        aria-label="current streak"
      >
        {current}
      </div>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
        <strong style={{ color: 'var(--fg-primary)', letterSpacing: '0.05em' }}>
          🔥 {t('streak.title')}
        </strong>
        <span style={{ fontSize: 11, color: 'var(--fg-text-dim)' }}>
          {t('streak.best')}: {longest} · {t('streak.fishies')}: {status?.fishies ?? 0}
        </span>
      </div>
    </div>
  );
}
